const initialOptions = {
  bookingTypeId: null,
  resourceType: null,
  scenario: null,
  adults: null,
  juniors: 0,
  games: null,
  timedGame: null,
  duration: null,
  date: null,
  time: null,
  scenarioFilter: null,
  promoCode: null,
  formData: {},
  priceKeys: {},
  addons: {}
}

// initial state
const state = {
  options: Object.assign({}, initialOptions),
  booking: {
    id: null
  }
}

// getters
const getters = {
  selectedAddons: state => {
    let addons = []
    for (let id in state.options.addons) {
      const addon = state.options.addons[id]
      if (addon.qty > 0)
        addons.push(addon)
    }
    return addons
  },
  selectedAddonsForApi: state => {
    let addons = {}
    for (let id in state.options.addons) {
      const addon = state.options.addons[id]
      if (addon.qty > 0)
        addons[id] = addon.qty
    }
    return addons
  },
  selectedAddonsTotal: state => {
    let total = 0
    for (let id in state.options.addons) {
      const addon = state.options.addons[id]
      if (addon.qty > 0)
        total += addon.addon.value * addon.qty
    }
    return total
  }
}

// actions
const actions = {
  setAddon ({ commit, state }, addon) {
    commit('setAddon', addon)
  },
  setPriceKeyQty ({ commit, state }, pk) {
    commit('setPriceKeyQty', pk)
  },
  initAddons ({ commit, state }, addons) {
    let _addons = {}
    for (let i = 0; i < addons.length; i++) {
      let addon = addons[i]
      _addons[addon.id] = { qty: 0, addon: addon }
      if (state.options.addons[addon.id])
        _addons[addon.id].qty = state.options.addons[addon.id].qty
    }
    commit('setAddons', _addons)
  },
  setBookingTypeId ({ commit, state }, bookingTypeId) {
    commit('setBookingTypeId', bookingTypeId)
  },
  setResourceType ({ commit, state }, resourceType) {
    commit('setResourceType', resourceType)
  },
  setScenario ({ commit, state }, scenario) {
    commit('setScenario', scenario)
  },
  setAdults ({ commit, state }, adults) {
    commit('setAdults', adults)
  },
  setJuniors ({ commit, state }, juniors) {
    commit('setJuniors', juniors)
  },
  setTimedGame ({ commit, state }, timedGame) {
    commit('setTimedGame', timedGame)
  },
  setGames ({ commit, state }, games) {
    commit('setGames', games)
  },
  setDuration ({ commit, state }, duration) {
    commit('setDuration', duration)
  },
  setDate ({ commit, state }, date) {
    commit('setDate', date)
  },
  setTime ({ commit, state }, time) {
    commit('setTime', time)
  },
  setScenarioFilter ({ commit, state }, scenarioIds) {
    commit('setScenarioFilter', scenarioIds ? [].concat(scenarioIds) : [])
  },
  setPromoCode ({ commit, state }, promoCode) {
    commit('setPromoCode', promoCode)
  },
  setBooking ({ commit, state }, booking) {
    commit('setBooking', booking)
  },
  setFormData ({ commit, state }, data ) {
    commit('setFormData', data )
  }
}

// mutations
const mutations = {
  setAddon (state, addon) {
    state.options.addons[addon.addon.id] = addon
  },
  setPriceKeys (state, priceKeys) {
    state.options.priceKeys = Object.assign({}, priceKeys)
  },
  setPriceKeyQty (state, pk) {
    state.options.priceKeys = Object.assign({}, state.options.priceKeys, pk)
  },
  setAddons (state, addons) {
    state.options.addons = addons
  },
  removeSelectedAddon(state, addonId) {
    state.options.addons[addonId].qty = 0
  },
  setBookingTypeId (state, bookingTypeId) {
    state.options.bookingTypeId = bookingTypeId
  },
  setResourceType (state, resourceType) {
    state.options.resourceType = resourceType
  },
  setScenario (state, scenario) {
    state.options.scenario = scenario
  },
  setAdults (state, adults) {
    state.options.adults = adults
  },
  setJuniors (state, juniors) {
    state.options.juniors = juniors
  },
  setTimedGame (state, timedGame) {
    state.options.timedGame = timedGame
  },
  setGames (state, games) {
    state.options.games = games
  },
  setDuration (state, duration) {
    state.options.duration = duration
  },
  setDate (state, date) {
    state.options.date = date
  },
  setTime (state, time) {
    state.options.time = time
  },
  setScenarioFilter (state, scenarioIds) {
    state.options.scenarioFilter = scenarioIds
  },
  setPromoCode (state, promoCode) {
    state.options.promoCode = promoCode
  },
  setBooking (state, booking) {
    state.booking = booking
  },
  setFormData (state, data) {
    state.options.formData = data
  },
  setOptions (state, options) {
    state.options = Object.assign(initialOptions, options)
  },
  resetOptions (state) {
    state.options = Object.assign({}, initialOptions)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
